import { katTranslator } from '../../shared/i18n';

export const strings = {
  // AST String ID: kat_progress_label
  progress_bar_label: {
    'en-US': 'Progress',
    'ml-IN': 'പുരോഗതി',
    'te-IN': 'పురోగతి',
    'fr-CA': 'Progression',
    'tr-TR': 'İlerleme.',
    'pl-PL': 'Postęp',
    'bn-IN': 'অগ্রগতি',
    'hi-IN': 'प्रगति',
    'it-IT': 'Avanzamento',
    'ta-IN': 'செயல்நிலை',
    'pt-PT': 'Progresso',
    'sv-SE': 'Framsteg',
    'fr-FR': 'Progression',
    'pt-BR': 'Andamento',
    'mr-IN': 'प्रगती',
    'cs-CZ': 'Pokrok',
    'fr-BE': 'Progression',
    'da-DK': 'Fremskridt',
    'zh-TW': '進度',
    'es-ES': 'Progreso',
    'ja-JP': '進捗状況',
    'ko-KR': '진행 상황',
    'nl-BE': 'Voortgang',
    'nl-NL': 'Voortgang',
    'ar-AE': 'التقدم',
    'de-DE': 'Fortschritt',
    'es-CL': 'Progreso',
    'he-IL': 'התקדמות',
    'zh-CN': '进度',
    'es-CO': 'Progreso',
    'es-US': 'Progreso',
    'es-MX': 'Progreso',
  },
};

export default katTranslator(strings);
